var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 0V1.16667H8.51083L2.77667 6.90083L3.59917 7.72333L9.33333 1.98917V4.08333H10.5V0M9.33333 9.33333H1.16667V1.16667H5.25V0H1.16667C0.519167 0 0 0.525 0 1.16667V9.33333C0 9.64275 0.122916 9.9395 0.341709 10.1583C0.560501 10.3771 0.857247 10.5 1.16667 10.5H9.33333C9.64275 10.5 9.9395 10.3771 10.1583 10.1583C10.3771 9.9395 10.5 9.64275 10.5 9.33333V5.25H9.33333V9.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalGuideIcon);
export default __webpack_public_path__ + "static/media/external-guide-icon.9261c3b677986e5534a9c9d6cba0fc86.svg";
export { ForwardRef as ReactComponent };